/* globals Class */
var h = require('virtual-dom/h');
var createElement = require('virtual-dom/create-element');

var BaseDialog = require('./base_dialog');

var render = function(action, contentType) {
  return createElement(
    h('.modal-content-container.error-container', [
      h('.publish-error-header', [
        h('.publish-icon.publish-error-icon.svg-ico-warning4'),
        h('.publish-label.error', [action.capitalize(), 'ing is not complete!'])
      ]),
      h('.modal-panel-description', [
        'We had a temporary issue while ',
        action,
        'ing your ',
        contentType.toLowerCase(),
        '.',
        h('br'),
        'Close this dialog and try to ',
        action,
        ' again.'
      ])
    ])
  );
};

var PublishErrorDialog = Class.create(BaseDialog, {

  initialize: function($super, options) {
    this.contentType = options.contentType;
    this.action = options.eventType === 'publishError' ? 'publish' : 'republish';

    var self = this;

    options = {
      clickOutsideWillClose: false,
      allowHeader: true,
      closeX: true,
      attributes: {
        className: 'modal-panel modal-panel-error'
      },
      actions: [
      {
        attributes: {
          id: 'close',
          className: 'flat-btn flat-btn-close flat-btn-with-icon push-left action button modal-button'
        },
        type: 'button',
        label: 'Got it',
        action: function() {
          self.close();
        }
      }]
    };

    $super(options);
  },

  installUI: function($super) {
    $super();

    this.setTitle('Unable to ' + this.action + ' your ' + this.contentType.toLowerCase());
    this.setContent(render(this.action, this.contentType));
  }
});

module.exports = PublishErrorDialog;



// WEBPACK FOOTER //
// ./src/lp/editor/dialogs/publish/publish_error.js